import styled from 'styled-components'

export const PopupInsideContainer = styled.div`
  display: flex;
  flex-direction: column;
`
